import { render, staticRenderFns } from "./myAssets.vue?vue&type=template&id=aca8f400&scoped=true"
import script from "./myAssets.vue?vue&type=script&lang=js"
export * from "./myAssets.vue?vue&type=script&lang=js"
import style0 from "./myAssets.vue?vue&type=style&index=0&id=aca8f400&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aca8f400",
  null
  
)

export default component.exports